import { render } from "./FeaturedGames.vue?vue&type=template&id=17b06969"
import script from "./FeaturedGames.vue?vue&type=script&lang=js"
export * from "./FeaturedGames.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__